export default {
  setBids (state, bids) {
    state.bids = bids
  }
}
